module.exports = __webpack_public_path__ + "static/media/400339_01.fc994312.png";